import {useMutation} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";
import {MaterialOrderDetails} from "../types/MaterialOrderDetails";
import {MaterialOrderSubmitResult} from "../types/MaterialOrderSubmitResult";

export const useSubmitMaterialOrder = (
	materialOrder: MaterialOrderDetails,
	onSuccess: (result: MaterialOrderSubmitResult) => void,
	onError: (error: string) => void
) => {

	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post("material-order/submit", { materialOrder }) as MaterialOrderSubmitResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess(result);
			else
				onError('Error when submitting material order: ' + result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
